import KeyboardEvent from '../../event/js/keyboard';
import {
  atGrowlerBtn,
  atHeaderElements,
  sidebarMenu,
  sidebarMenuLevels,
  sidebarMenuToggleButton,
} from './global';

const getCurrentMenuLevel = () => Number(sidebarMenu.dataset.level);
const getCurrentElementMenuInner = () => sidebarMenuLevels[getCurrentMenuLevel()]();

const getNavigableElements = () => {
  const navigationListElements = getCurrentElementMenuInner() ? Array.from(getCurrentElementMenuInner().querySelectorAll(':scope > .at-sidebar-menu__item > a')) : [];

  // array of elements considered as focusable when the sidebarmenu is open. if the element does not exist is filtered out from here
  return [
    atGrowlerBtn,
    ...Object.values(atHeaderElements),
    sidebarMenuToggleButton,
    ...navigationListElements]
    .filter((el) => el);
};

const getTargetItem = (target, direction = 'next') => {
  const navigableElements = getNavigableElements();
  const targetIndex = navigableElements.indexOf(target);
  const isNextTarget = direction === 'next';
  let newIndex = isNextTarget ? targetIndex + 1 : targetIndex - 1;
  if (newIndex > navigableElements.length - 1) newIndex = 0;
  if (newIndex < 0) newIndex = navigableElements.length - 1;
  const newTargetedItem = navigableElements[newIndex || 0];

  return newTargetedItem;
};

export const getObjectIndexInArray = (array, element = null) => (element ? array.findIndex((el) => el === element) || 0 : 0);

export const focusAnchor = (anchorsList, elementIndex = 0) => setTimeout(() => {
  if (anchorsList.length) {
    anchorsList[elementIndex].focus();
  }
}, 100);

class SidebarMenuKeyboardNavigation {
  static keydownHandler = (userEvent) => {
    const { target } = userEvent;
    userEvent.preventDefault();

    switch (true) {
      case KeyboardEvent.CheckKey(userEvent, KeyboardEvent.Key.TAB):
        getTargetItem(target, userEvent.shiftKey ? 'prev' : 'next').focus();
        break;
      case KeyboardEvent.CheckKey(userEvent, KeyboardEvent.Key.UP):
        getTargetItem(target, 'prev').focus();
        break;
      case KeyboardEvent.CheckKey(userEvent, KeyboardEvent.Key.DOWN):
        getTargetItem(target, 'next').focus();
        break;
      case KeyboardEvent.CheckKey(userEvent, KeyboardEvent.Key.LEFT):
      case KeyboardEvent.CheckKey(userEvent, KeyboardEvent.Key.BACKSPACE):
      case KeyboardEvent.CheckKey(userEvent, KeyboardEvent.Key.ESC):
        if (getCurrentMenuLevel() > 1) {
          const navigableElements = getNavigableElements();
          const toggleBtnIndex = getObjectIndexInArray(navigableElements, sidebarMenuToggleButton);
          navigableElements[toggleBtnIndex + 1].click();
          focusAnchor(navigableElements, toggleBtnIndex);
        } else if (sidebarMenuToggleButton.ariaExpanded === 'true') {
          sidebarMenuToggleButton.click();
          sidebarMenuToggleButton.focus();
        }
        break;
      case KeyboardEvent.CheckKey(userEvent, KeyboardEvent.Key.SPACE):
      case KeyboardEvent.CheckKey(userEvent, KeyboardEvent.Key.ENTER): {
        target.click();
        const svgs = target.querySelectorAll('svg');
        const targetHasChildren = Array.from(svgs).some((svg) => svg.innerHTML.includes('icon-chevron'));
        if (targetHasChildren) {
          const navigableElements = getNavigableElements();
          const toggleBtnIndex = getObjectIndexInArray(navigableElements, sidebarMenuToggleButton);
          focusAnchor(navigableElements, getCurrentMenuLevel() > 1 ? toggleBtnIndex + 1 : toggleBtnIndex);
        }
        break;
      }
      default:
        break;
    }
  };
}

export default SidebarMenuKeyboardNavigation;